var initializeBlockAccordion = function(block){
    
    jQuery(".accordion .row > h3", block).click(function(){
		
		var currentRow = jQuery(this).parent();
		var closeOnly = false;
		
		if(currentRow.hasClass("active"))
			closeOnly = true;
			
		var parent = currentRow.parents(".accordion");
		var previousSelected = jQuery(".active", parent).removeClass("active");	
		
		// Reset previous row's background alpha
		var prevBg = previousSelected.css('background-color');
		if(prevBg) {
			// Convert RGB to RGBA if needed
			if(prevBg.indexOf('rgb(') > -1) {
				prevBg = prevBg.replace('rgb(', 'rgba(').replace(')', ', 1)');
			} else {
				prevBg = prevBg.replace(/[\d.]+\)$/g, '1)');
			}
			previousSelected.css('background-color', prevBg);
		}
		
		jQuery('.content', previousSelected).slideToggle(300);
		
		if(!closeOnly){
			currentRow.toggleClass('active');
			
			// Update current row's background alpha
			var bg = currentRow.css('background-color');
			if(bg) {
				// Convert RGB to RGBA if needed
				if(bg.indexOf('rgb(') > -1) {
					bg = bg.replace('rgb(', 'rgba(').replace(')', ', 0.15)');
				} else {
					bg = bg.replace(/[\d.]+\)$/g, '0.15)');
				}
				currentRow.css('background-color', bg);
			}
			
			jQuery('.content', currentRow).slideToggle(300);
		}
		
	});
    
}

//initialize each block on front end
jQuery(document).ready(function(){
    jQuery('.wp-block-accordion').each(function(){
        initializeBlockAccordion(jQuery(this));
    });
});

//initialize dynamic block preview in the editor
if(window.acf)
    window.acf.addAction('render_block_preview/type=accordion', initializeBlockAccordion);
